import { Stack, Typography, Button, Divider } from "../";
import AssignedDriver from "../AssignedDriver";
import LogisticTaskStatus from "../LogisticTaskStatus";
import Spacer from "../Spacer";

import { TaskStatusEnum } from "digiwash-core";
import React from "react";
import { Linking, Platform, Alert } from "react-native";
import { useConter } from ".";

enum TaskTypeEnum {
  collection = "collection",
  delivery = "delivery",
}

interface LogesticTaskInOrder {
  id: number;
  address_text: string;
  period: Period;
  task_type: TaskTypeEnum;
  status: TaskStatusEnum;
  address_longitude: number;
  address_latitude: number;
  driver?: Driver;
  in_person?: boolean;
}
interface Driver {
  id: number;
  first_name: string;
  last_name: string;
  cellphone: string;
}

interface Period {
  id: number;
  date: string;
  title: string;
  start: string;
  end: string;
}

interface LogisticTaskFooterType {
  data: LogesticTaskInOrder;
  onCanceled?: () => void;
  onAdd?: () => void;
  onReschedule?: () => void;
  policy?: string;
  logisticTimeIcon?: React.ReactNode;
  inPerson?: boolean;
}
const confirmationAlert = (type: string, action?: () => void) => {
  if (Platform.OS === "web") {
    let confirmed = confirm(
      `آیا از لغو ${type === "delivery" ? "تحویل" : "جمع آوری"} مطمئن هستید؟`
    );
    if (confirmed && action) {
      action();
    } else {
    }
  } else {
    Alert.alert(
      "ذخیره تغییرات",
      `آیا از لغو ${type === "delivery" ? "تحویل" : "جمع آوری"} مطمئن هستید؟`,
      [
        {
          text: "انصراف",
          style: "cancel",
        },
        {
          text: "تایید",
          onPress: () => {
            if (action) {
              action();
            }
          },
        },
      ],
      { cancelable: false }
    );
  }
};

function normalizeInputUseCounter(
  date: string,
  end: string,
  policy?: string
): string {
  if (!!date && policy === "customer") {
    let [a] = date.split("T");
    return `${a}T${end}`;
  } else {
    return "";
  }
}

function LogisticTaskFooter(props: LogisticTaskFooterType) {
  let taskStatus = props.data?.status;
  let logisticTypeText =
    props.data.task_type === "delivery" ? "تحویل" : "جمع آوری";
  let notAllowedToChangeTask =
    taskStatus === "not_present" ||
    taskStatus === "canceled" ||
    taskStatus === "done";

  let showTimerOnCollection =
    taskStatus === "unassigned" || taskStatus === "assigned";
  let showTimerOnDelivery =
    taskStatus === "unassigned" ||
    taskStatus === "assigned" ||
    taskStatus === "loaded";
  let showTimer =
    props.data.task_type === "collection"
      ? showTimerOnCollection
      : showTimerOnDelivery;
  let { text } = useConter(
    normalizeInputUseCounter(
      props.data?.period?.date,
      props.data?.period?.end,
      props.policy
    ),
    showTimer
  );
  let footer: React.ReactNode = [];
  if (taskStatus === "canceled") {
    footer.push(
      <Typography color="red.dark">{logisticTypeText} لغو شده است.</Typography>
    );
  } else if (!!props.data?.driver) {
    footer.push(
      <AssignedDriver
        data={props.data.driver}
        info={
          props.inPerson ? (
            <Button
              onPress={() => {
                Linking.openURL(
                  `https://www.google.com/maps/place/${props.data?.address_longitude},${props.data?.address_latitude}`
                );
              }}
            >
              نمایش در نقشه
            </Button>
          ) : (
            <LogisticTaskStatus status={taskStatus} />
          )
        }
      />
    );
  }

  if (
    !notAllowedToChangeTask &&
    props.onCanceled &&
    props.policy === "pishkhan"
  ) {
    footer.push(
      <Stack>
        <Button
          onPress={() =>
            confirmationAlert(props.data.task_type, props.onCanceled)
          }
          fill="transparent"
          textColor="red.dark"
        >
          لغو {logisticTypeText}{" "}
        </Button>
      </Stack>
    );
  }
  if (props.onAdd) {
    footer.push(
      <Stack>
        <Button
          onPress={() => {
            if (props.onAdd) {
              props.onAdd();
            }
          }}
          fill
        >
          تنظیم زمان {logisticTypeText}{" "}
        </Button>
      </Stack>
    );
  }
  if (props.data.status === "unassigned" && props.policy === "customer") {
    footer.push(
      <>
        <Stack>
          <Button onPress={props.onReschedule} fill>
            تغییر زمان
          </Button>
        </Stack>
      </>
    );
  }

  // id=0 is for client-generated task
  if (showTimer && !!text && props.data.id != 0) {
    footer.push(
      <>
        <Stack distribution="space-between" px="s">
          <Typography>تا {logisticTypeText} سفارش</Typography>
          <Stack distribution="center">
            <Typography ff="mainBold">{text}</Typography>
            <Spacer size="m" />
            {props.logisticTimeIcon}
          </Stack>
        </Stack>
      </>
    );
  }

  return (
    <>
      {footer.map((component, index) => {
        if (footer.length - 1 === index) {
          return <React.Fragment key={index}>{component}</React.Fragment>;
        } else {
          return (
            <React.Fragment key={index}>
              {component}
              <Divider size="xxxl" />
            </React.Fragment>
          );
        }
      })}
    </>
  );
}

export default LogisticTaskFooter;
